import { Fragment, FunctionComponent, useState } from 'react';
import { DraftConfiguration } from '@/types';
import { t } from '@/utils/i18n';
import { SubPanel } from '@/components/common/panel/panel';
import { ColorSelector } from '../ColorSelector';
import { PrintTypePanel, PrintTypeSelectorButton } from '../PrintTypePanel';

enum SubPanels {
  None,
  PrintType,
}

interface ColorListProps {
  configuration: DraftConfiguration;
  active: boolean;
  onBackClick: () => void;
}

export const ColorList: FunctionComponent<ColorListProps> = ({
  configuration,
  active,
  onBackClick,
}) => {
  const [activeSubPanel, setActiveSubPanel] = useState(SubPanels.None);

  return (
    <Fragment>
      <SubPanel
        active={active}
        headline={t('configuration.text.color')}
        parent={t('textSettings.label')}
        className="color-list"
        onBack={onBackClick}
      >
        <PrintTypeSelectorButton
          printType={configuration.printType}
          onClick={() => setActiveSubPanel(SubPanels.PrintType)}
        />
        <ColorSelector configuration={configuration} />
      </SubPanel>
      <PrintTypePanel
        active={activeSubPanel === SubPanels.PrintType}
        parent={t('configuration.text.color')}
        configuration={configuration}
        onBackClick={() => setActiveSubPanel(SubPanels.None)}
      />
    </Fragment>
  );
};
